
import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-gray-50 to-gray-100 py-16">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Terms of Service
              </h1>
              <p className="text-xl text-gray-600">
                Please read these terms carefully before using our services and products.
              </p>
              <div className="mt-6 text-sm text-gray-500">
                Last updated: December 2024
              </div>
            </div>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-16">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto prose prose-lg">
              
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">Acceptance of Terms</h2>
                <p className="text-gray-700 mb-4">
                  By accessing and using Lavin Enterprises & Co. services, you accept and agree to be bound 
                  by the terms and provision of this agreement. If you do not agree to abide by the above, 
                  please do not use this service.
                </p>
                <p className="text-gray-700">
                  These terms apply to all visitors, users, and others who access or use our services, 
                  including our website, products, and customer support.
                </p>
              </div>

              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">Use License</h2>
                <p className="text-gray-700 mb-4">
                  Permission is granted to temporarily access our services for personal, non-commercial 
                  transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>Modify or copy the materials</li>
                  <li>Use the materials for any commercial purpose or for any public display</li>
                  <li>Attempt to reverse engineer any software contained on our website</li>
                  <li>Remove any copyright or other proprietary notations from the materials</li>
                  <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
                </ul>
              </div>

              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">Product Information and Orders</h2>
                <p className="text-gray-700 mb-4">
                  We strive to provide accurate product information, but we do not warrant that product 
                  descriptions or other content is accurate, complete, reliable, current, or error-free.
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>All orders are subject to acceptance and availability</li>
                  <li>We reserve the right to refuse or cancel any order</li>
                  <li>Prices are subject to change without notice</li>
                  <li>Product specifications may vary based on application requirements</li>
                  <li>Technical data sheets are provided for guidance only</li>
                </ul>
              </div>

              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">Payment Terms</h2>
                <p className="text-gray-700 mb-4">
                  Payment terms and conditions for our products and services:
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>Payment is due upon receipt of invoice unless otherwise agreed</li>
                  <li>Late payments may incur additional charges</li>
                  <li>We accept various payment methods as specified in your order</li>
                  <li>All prices are exclusive of applicable taxes unless stated otherwise</li>
                  <li>Currency exchange rates may affect international orders</li>
                </ul>
              </div>

              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">Shipping and Delivery</h2>
                <p className="text-gray-700 mb-4">
                  Shipping and delivery terms for our chemical products:
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>Delivery times are estimates and not guaranteed</li>
                  <li>Risk of loss transfers upon delivery to carrier</li>
                  <li>Special handling may be required for hazardous materials</li>
                  <li>International shipments subject to customs regulations</li>
                  <li>Damaged or missing items must be reported within 48 hours</li>
                </ul>
              </div>

              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">Product Warranty and Liability</h2>
                <p className="text-gray-700 mb-4">
                  Our products are warranted to meet published specifications when used as directed:
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>Warranty period varies by product type and application</li>
                  <li>Proper storage and handling conditions must be maintained</li>
                  <li>Warranty is void if products are modified or misused</li>
                  <li>Our liability is limited to product replacement or refund</li>
                  <li>Consequential damages are excluded to the fullest extent permitted by law</li>
                </ul>
              </div>

              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">Safety and Compliance</h2>
                <p className="text-gray-700 mb-4">
                  Users are responsible for safe handling and compliance with regulations:
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>Review all safety data sheets before use</li>
                  <li>Comply with local, state, and federal regulations</li>
                  <li>Use appropriate personal protective equipment</li>
                  <li>Ensure proper ventilation and storage conditions</li>
                  <li>Dispose of materials according to environmental regulations</li>
                </ul>
              </div>

              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">Intellectual Property</h2>
                <p className="text-gray-700 mb-4">
                  All content, trademarks, and intellectual property rights are protected:
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>Lavin Enterprises & Co. owns all proprietary formulations</li>
                  <li>Technical documentation is confidential and proprietary</li>
                  <li>Reverse engineering of products is prohibited</li>
                  <li>Use of our trademarks requires written permission</li>
                  <li>Customer data and project information remain confidential</li>
                </ul>
              </div>

              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">Termination</h2>
                <p className="text-gray-700 mb-4">
                  Either party may terminate this agreement under certain conditions:
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>Breach of terms that remains uncured after notice</li>
                  <li>Insolvency or bankruptcy proceedings</li>
                  <li>Violation of safety or regulatory requirements</li>
                  <li>Mutual agreement between parties</li>
                  <li>Outstanding obligations survive termination</li>
                </ul>
              </div>

              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">Contact Information</h2>
                <p className="text-gray-700 mb-4">
                  For questions about these Terms of Service, please contact us:
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-gray-700 mb-2"><strong>Email:</strong> legal@lavinenterprises.com</p>
                  <p className="text-gray-700 mb-2"><strong>Phone:</strong> +1 (555) 123-4567</p>
                  <p className="text-gray-700"><strong>Address:</strong> 123 Industrial Boulevard, Chemical District, CD 12345</p>
                </div>
              </div>

              <div className="bg-amber-50 border border-amber-200 rounded-lg p-6">
                <h3 className="text-lg font-semibold text-amber-900 mb-2">Terms Updates</h3>
                <p className="text-amber-800">
                  We reserve the right to modify these terms at any time. Changes will be effective 
                  immediately upon posting. Your continued use of our services constitutes acceptance of the modified terms.
                </p>
              </div>

            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
